// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"98860dfa","830":"bf0e445e"}[chunkId] + ".chunk.js";
};